/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：弹出框的拖拽功能
 * 更新记录: 
 */
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[SwDragModal]'
})
export class SwDragModalDirective {
  private isDown = false;
  private disX = 0;
  private disY = 0;

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  @HostListener('dragend', ['$event']) ondragend(event) {
    event.preventDefault()
    let newdisX = event.clientX;
    let newdisY = event.clientY;
    let oLeft = newdisX - this.disX;
    let oTop = newdisY - this.disY;
    // var bodyRect = document.body.getBoundingClientRect();
    //相差的距离,重要
    var topHeight = this.el.nativeElement.offsetTop - this.el.nativeElement.getBoundingClientRect().top;

    // var right=document.body.offsetWidth-this.el.nativeElement.getBoundingClientRect().right; //距离右边的距离
    // var bottom=document.body.clientHeight-this.el.nativeElement.getBoundingClientRect().bottom; //距离下边的距离
    //如果定位小于0,超出屏幕,则为重置为0
    if (oLeft <= 0) {
      oLeft = 0;
    }
    if (oTop - topHeight <= 0) {
      oTop = topHeight;
    }
    //定位改变弹出框位置
    this.el.nativeElement.style.position = 'absolute';
    this.el.nativeElement.style.left = oLeft + 'px';
    this.el.nativeElement.style.top = oTop + 'px';
    try{
      event.target.removeAttribute("draggable")
    }catch(e){}
}

  // 点击事件
  @HostListener('mousedown', ['$event']) onClick(event) {
    if(event && event.stopPropagation){
      event.stopPropagation();
    }else{
      window.event.cancelBubble=true;
    }
    // 禁止选中close
    if(!event.target.className){
      return;
    }

    try{
      if (event.target.className.indexOf('modal-header')>-1  || event.target.className.indexOf('modalheader')>-1) {
        // 移动区域
        //draggable="true"
        this.isDown = true;
        event.target.parentElement.parentElement.setAttribute("draggable",true)
        this.disX = event.clientX - this.el.nativeElement.offsetLeft;
        this.disY = event.clientY - this.el.nativeElement.offsetTop;
      }
    }catch(e){}
  }

  // // 监听document移动事件事件
  // @HostListener('mousemove', ['$event']) onMousemove(event) {
  //   if(event && event.stopPropagation){
  //     event.stopPropagation();
  //   }else{
  //     window.event.cancelBubble=true;
  //   }
  //   // 判断该元素是否被点击了。
  //   if (this.isDown) {
  //     // 移动中;
  //     //鼠标的位置
  //     let newdisX = event.clientX;
  //     let newdisY = event.clientY;
  //     let oLeft = newdisX - this.disX;
  //     let oTop = newdisY - this.disY;
  //     // var bodyRect = document.body.getBoundingClientRect();
  //     //相差的距离,重要
  //     var topHeight=this.el.nativeElement.offsetTop-this.el.nativeElement.getBoundingClientRect().top;

  //     // var right=document.body.offsetWidth-this.el.nativeElement.getBoundingClientRect().right; //距离右边的距离
  //     // var bottom=document.body.clientHeight-this.el.nativeElement.getBoundingClientRect().bottom; //距离下边的距离
  //     //如果定位小于0,超出屏幕,则为重置为0
  //     if(oLeft<=0){
  //       oLeft=0;
  //     }
  //     if(oTop-topHeight<=0){
  //       oTop=topHeight;
  //     }
  //     //定位改变弹出框位置
  //     this.el.nativeElement.style.position = 'absolute';
  //     this.el.nativeElement.style.left = oLeft + 'px';
  //     this.el.nativeElement.style.top = oTop+ 'px';
  //   }
  // }
  // // 监听document离开事件

  // @HostListener('mouseup', ['$event']) onMouseup() {
  //   this.isDown = false;
  //   if(event && event.stopPropagation){
  //     event.stopPropagation();
  //   }else{
  //     window.event.cancelBubble=true;
  //   }
  //   // 只用当元素移动过了，离开函数体才会触发。
  //   if (this.isDown) {
  //     document.onmousemove = null;
  //     document.onmouseup = null;

  //   }
  // }

  // //监听鼠标移出事件
  // @HostListener('mouseleave', ['$event']) onmouseleave() {
  //   this.isDown = false;
  //   if(event && event.stopPropagation){
  //     event.stopPropagation();
  //   }else{
  //     window.event.cancelBubble=true;
  //   }
  //   // 只用当元素移动过了，离开函数体才会触发。
  //   if (this.isDown) {
  //     document.onmousemove = null;
  //     document.onmouseup = null;

  //   }
  // }
}
